// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file organization_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { SyncUpdate, SyncUpdateProfile } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { VaultCreationData, VaultPairCreationData } from "./vault_service_pb";
import { file_vault_service } from "./vault_service_pb";
import type { ProfileData, ProfileRegenerateData } from "./profile_pb";
import { file_profile } from "./profile_pb";
import type { UnlockTimeLimit } from "./unlock_time_limit_pb";
import { file_unlock_time_limit } from "./unlock_time_limit_pb";
import type { ProfileProfileLock, VaultProfileLock } from "./locks_pb";
import { file_locks } from "./locks_pb";
import type { SubscriptionPlan } from "./subscription_plan_pb";
import { file_subscription_plan } from "./subscription_plan_pb";
import type { ExportPermission, RolePermissions } from "./role_pb";
import { file_role } from "./role_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file organization_service.proto.
 */
export const file_organization_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_sync_update, file_vault_service, file_profile, file_unlock_time_limit, file_locks, file_google_protobuf_wrappers, file_subscription_plan, file_role]);

/**
 * @generated from message domain.SubscriptionStatus
 */
export type SubscriptionStatus = Message<"domain.SubscriptionStatus"> & {
  /**
   * @generated from oneof domain.SubscriptionStatus.status
   */
  status: {
    /**
     * @generated from field: domain.SubscriptionStatus.PaddleActive status_paddle_active = 1;
     */
    value: SubscriptionStatus_PaddleActive;
    case: "statusPaddleActive";
  } | {
    /**
     * @generated from field: domain.SubscriptionStatus.PaddlePastDue status_paddle_past_due = 2;
     */
    value: SubscriptionStatus_PaddlePastDue;
    case: "statusPaddlePastDue";
  } | {
    /**
     * @generated from field: domain.SubscriptionStatus.PaddlePausedDelinquent status_paddle_paused_delinquent = 3;
     */
    value: SubscriptionStatus_PaddlePausedDelinquent;
    case: "statusPaddlePausedDelinquent";
  } | {
    /**
     * @generated from field: domain.SubscriptionStatus.PaddlePausedVoluntary status_paddle_paused_voluntary = 4;
     */
    value: SubscriptionStatus_PaddlePausedVoluntary;
    case: "statusPaddlePausedVoluntary";
  } | {
    /**
     * @generated from field: domain.SubscriptionStatus.PaddleDeleted status_paddle_deleted = 5;
     */
    value: SubscriptionStatus_PaddleDeleted;
    case: "statusPaddleDeleted";
  } | {
    /**
     * @generated from field: domain.SubscriptionStatus.Trial status_trial = 6;
     */
    value: SubscriptionStatus_Trial;
    case: "statusTrial";
  } | {
    /**
     * @generated from field: domain.SubscriptionStatus.Custom status_custom = 7;
     */
    value: SubscriptionStatus_Custom;
    case: "statusCustom";
  } | {
    /**
     * @generated from field: domain.SubscriptionStatus.ActiveFree status_active_free = 8;
     */
    value: SubscriptionStatus_ActiveFree;
    case: "statusActiveFree";
  } | {
    /**
     * @generated from field: domain.SubscriptionStatus.Example status_example = 9;
     */
    value: SubscriptionStatus_Example;
    case: "statusExample";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message domain.SubscriptionStatus.
 * Use `create(SubscriptionStatusSchema)` to create a new message.
 */
export const SubscriptionStatusSchema: GenMessage<SubscriptionStatus> = /*@__PURE__*/
  messageDesc(file_organization_service, 0);

/**
 * https://developer.paddle.com/webhook-reference/ZG9jOjI1MzUzOTk0-subscription-created
 * status == "active"
 *
 * @generated from message domain.SubscriptionStatus.PaddleActive
 */
export type SubscriptionStatus_PaddleActive = Message<"domain.SubscriptionStatus.PaddleActive"> & {
  /**
   * @generated from field: string base_url = 1;
   */
  baseUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp next_bill_date = 2;
   */
  nextBillDate?: Timestamp | undefined;

  /**
   * @generated from field: int32 free_members = 3;
   */
  freeMembers: number;

  /**
   * @generated from field: string email = 4;
   */
  email: string;
};

/**
 * Describes the message domain.SubscriptionStatus.PaddleActive.
 * Use `create(SubscriptionStatus_PaddleActiveSchema)` to create a new message.
 */
export const SubscriptionStatus_PaddleActiveSchema: GenMessage<SubscriptionStatus_PaddleActive> = /*@__PURE__*/
  messageDesc(file_organization_service, 0, 0);

/**
 * https://developer.paddle.com/webhook-reference/ZG9jOjI1MzUzOTk1-subscription-updated
 * status == "past_due"
 *
 * @generated from message domain.SubscriptionStatus.PaddlePastDue
 */
export type SubscriptionStatus_PaddlePastDue = Message<"domain.SubscriptionStatus.PaddlePastDue"> & {
  /**
   * @generated from field: string base_url = 1;
   */
  baseUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp next_bill_date = 2;
   */
  nextBillDate?: Timestamp | undefined;

  /**
   * @generated from field: int32 free_members = 3;
   */
  freeMembers: number;
};

/**
 * Describes the message domain.SubscriptionStatus.PaddlePastDue.
 * Use `create(SubscriptionStatus_PaddlePastDueSchema)` to create a new message.
 */
export const SubscriptionStatus_PaddlePastDueSchema: GenMessage<SubscriptionStatus_PaddlePastDue> = /*@__PURE__*/
  messageDesc(file_organization_service, 0, 1);

/**
 * https://developer.paddle.com/webhook-reference/ZG9jOjI1MzUzOTk1-subscription-updated
 * status == "paused" && paused_reason == "delinquent"
 *
 * @generated from message domain.SubscriptionStatus.PaddlePausedDelinquent
 */
export type SubscriptionStatus_PaddlePausedDelinquent = Message<"domain.SubscriptionStatus.PaddlePausedDelinquent"> & {
  /**
   * @generated from field: string base_url = 1;
   */
  baseUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp paused_at = 2;
   */
  pausedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp paused_from = 3;
   */
  pausedFrom?: Timestamp | undefined;

  /**
   * @generated from field: int32 free_members = 4;
   */
  freeMembers: number;
};

/**
 * Describes the message domain.SubscriptionStatus.PaddlePausedDelinquent.
 * Use `create(SubscriptionStatus_PaddlePausedDelinquentSchema)` to create a new message.
 */
export const SubscriptionStatus_PaddlePausedDelinquentSchema: GenMessage<SubscriptionStatus_PaddlePausedDelinquent> = /*@__PURE__*/
  messageDesc(file_organization_service, 0, 2);

/**
 * https://developer.paddle.com/webhook-reference/ZG9jOjI1MzUzOTk1-subscription-updated
 * status == "paused" && paused_reason == "voluntary"
 *
 * @generated from message domain.SubscriptionStatus.PaddlePausedVoluntary
 */
export type SubscriptionStatus_PaddlePausedVoluntary = Message<"domain.SubscriptionStatus.PaddlePausedVoluntary"> & {
  /**
   * @generated from field: string base_url = 1;
   */
  baseUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp paused_at = 2;
   */
  pausedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp paused_from = 3;
   */
  pausedFrom?: Timestamp | undefined;

  /**
   * @generated from field: int32 free_members = 4;
   */
  freeMembers: number;
};

/**
 * Describes the message domain.SubscriptionStatus.PaddlePausedVoluntary.
 * Use `create(SubscriptionStatus_PaddlePausedVoluntarySchema)` to create a new message.
 */
export const SubscriptionStatus_PaddlePausedVoluntarySchema: GenMessage<SubscriptionStatus_PaddlePausedVoluntary> = /*@__PURE__*/
  messageDesc(file_organization_service, 0, 3);

/**
 * https://developer.paddle.com/webhook-reference/ZG9jOjI1MzUzOTk2-subscription-cancelled
 * status == "deleted"
 *
 * @generated from message domain.SubscriptionStatus.PaddleDeleted
 */
export type SubscriptionStatus_PaddleDeleted = Message<"domain.SubscriptionStatus.PaddleDeleted"> & {
  /**
   * @generated from field: google.protobuf.Timestamp cancellation_effective_date = 1;
   */
  cancellationEffectiveDate?: Timestamp | undefined;

  /**
   * @generated from field: int32 free_members = 2;
   */
  freeMembers: number;
};

/**
 * Describes the message domain.SubscriptionStatus.PaddleDeleted.
 * Use `create(SubscriptionStatus_PaddleDeletedSchema)` to create a new message.
 */
export const SubscriptionStatus_PaddleDeletedSchema: GenMessage<SubscriptionStatus_PaddleDeleted> = /*@__PURE__*/
  messageDesc(file_organization_service, 0, 4);

/**
 * if not subscribed via paddle, while trial is active
 *
 * @generated from message domain.SubscriptionStatus.Trial
 */
export type SubscriptionStatus_Trial = Message<"domain.SubscriptionStatus.Trial"> & {
  /**
   * @generated from field: google.protobuf.Timestamp trial_end_date = 1;
   */
  trialEndDate?: Timestamp | undefined;
};

/**
 * Describes the message domain.SubscriptionStatus.Trial.
 * Use `create(SubscriptionStatus_TrialSchema)` to create a new message.
 */
export const SubscriptionStatus_TrialSchema: GenMessage<SubscriptionStatus_Trial> = /*@__PURE__*/
  messageDesc(file_organization_service, 0, 5);

/**
 * if not subscribed via paddle, but currently free due to free users
 * note it's currently not possible to combine paddle and appsumo. we might
 * add that later by adding the free_members field to paddle statuses.
 *
 * @generated from message domain.SubscriptionStatus.ActiveFree
 */
export type SubscriptionStatus_ActiveFree = Message<"domain.SubscriptionStatus.ActiveFree"> & {
  /**
   * @generated from field: int32 free_members = 1;
   */
  freeMembers: number;
};

/**
 * Describes the message domain.SubscriptionStatus.ActiveFree.
 * Use `create(SubscriptionStatus_ActiveFreeSchema)` to create a new message.
 */
export const SubscriptionStatus_ActiveFreeSchema: GenMessage<SubscriptionStatus_ActiveFree> = /*@__PURE__*/
  messageDesc(file_organization_service, 0, 6);

/**
 * custom license message, displayed as passthrough text
 *
 * @generated from message domain.SubscriptionStatus.Custom
 */
export type SubscriptionStatus_Custom = Message<"domain.SubscriptionStatus.Custom"> & {
  /**
   * @generated from field: string left = 1;
   */
  left: string;

  /**
   * @generated from field: string right = 2;
   */
  right: string;
};

/**
 * Describes the message domain.SubscriptionStatus.Custom.
 * Use `create(SubscriptionStatus_CustomSchema)` to create a new message.
 */
export const SubscriptionStatus_CustomSchema: GenMessage<SubscriptionStatus_Custom> = /*@__PURE__*/
  messageDesc(file_organization_service, 0, 7);

/**
 * example license, displayed as passthrough text, used for demos
 *
 * @generated from message domain.SubscriptionStatus.Example
 */
export type SubscriptionStatus_Example = Message<"domain.SubscriptionStatus.Example"> & {
  /**
   * @generated from field: string left = 1;
   */
  left: string;

  /**
   * @generated from field: string right = 2;
   */
  right: string;
};

/**
 * Describes the message domain.SubscriptionStatus.Example.
 * Use `create(SubscriptionStatus_ExampleSchema)` to create a new message.
 */
export const SubscriptionStatus_ExampleSchema: GenMessage<SubscriptionStatus_Example> = /*@__PURE__*/
  messageDesc(file_organization_service, 0, 8);

/**
 * @generated from message domain.CreateOrganizationRequest
 */
export type CreateOrganizationRequest = Message<"domain.CreateOrganizationRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string icon = 2;
   */
  icon: string;

  /**
   * @generated from field: string email = 17;
   */
  email: string;

  /**
   * used for automatically fetching organization icon, will be derived from email if omitted
   *
   * @generated from field: string domain = 24;
   */
  domain: string;

  /**
   * @generated from field: domain.ProfileData user_profile = 16;
   */
  userProfile?: ProfileData | undefined;

  /**
   * @generated from field: domain.ProfileData admin_profile = 21;
   */
  adminProfile?: ProfileData | undefined;

  /**
   * @generated from field: domain.VaultCreationData admin_vault_data = 23;
   */
  adminVaultData?: VaultCreationData | undefined;

  /**
   * Optional for now. We need to wait for clients to support sending login summary update messages
   * before we can start creating summary vaults for orgs.
   *
   * @generated from field: domain.VaultCreationData login_summary_vault_data = 25;
   */
  loginSummaryVaultData?: VaultCreationData | undefined;

  /**
   * @generated from field: domain.VaultCreationData personal_vault_data = 7;
   */
  personalVaultData?: VaultCreationData | undefined;

  /**
   * @generated from field: bytes personal_vault_superuser_encrypted_storable_vault_key = 8;
   */
  personalVaultSuperuserEncryptedStorableVaultKey: Uint8Array;

  /**
   * @generated from field: bytes personal_vault_superuser_encrypted_high_security_vault_key = 9;
   */
  personalVaultSuperuserEncryptedHighSecurityVaultKey: Uint8Array;

  /**
   * @generated from field: bytes personal_vault_superuser_encrypted_vault_message_private_key = 18;
   */
  personalVaultSuperuserEncryptedVaultMessagePrivateKey: Uint8Array;

  /**
   * optional, creates an initial team for the org if present
   *
   * @generated from field: domain.VaultPairCreationData team_vault_data = 10;
   */
  teamVaultData?: VaultPairCreationData | undefined;

  /**
   * @generated from field: bytes team_vault_superuser_encrypted_storable_vault_key = 11;
   */
  teamVaultSuperuserEncryptedStorableVaultKey: Uint8Array;

  /**
   * @generated from field: bytes team_vault_superuser_encrypted_high_security_vault_key = 12;
   */
  teamVaultSuperuserEncryptedHighSecurityVaultKey: Uint8Array;

  /**
   * @generated from field: bytes team_vault_superuser_encrypted_vault_message_private_key = 19;
   */
  teamVaultSuperuserEncryptedVaultMessagePrivateKey: Uint8Array;

  /**
   * @generated from field: bytes team_associated_vault_superuser_encrypted_storable_vault_key = 13;
   */
  teamAssociatedVaultSuperuserEncryptedStorableVaultKey: Uint8Array;

  /**
   * @generated from field: bytes team_associated_vault_superuser_encrypted_high_security_vault_key = 14;
   */
  teamAssociatedVaultSuperuserEncryptedHighSecurityVaultKey: Uint8Array;

  /**
   * @generated from field: bytes team_associated_vault_superuser_encrypted_vault_message_private_key = 20;
   */
  teamAssociatedVaultSuperuserEncryptedVaultMessagePrivateKey: Uint8Array;

  /**
   * optional
   *
   * @generated from field: string contact_json = 15;
   */
  contactJson: string;

  /**
   * @generated from field: domain.CreateOrganizationRequest.ParentOrganizationInfo parent_organization_info = 22;
   */
  parentOrganizationInfo?: CreateOrganizationRequest_ParentOrganizationInfo | undefined;
};

/**
 * Describes the message domain.CreateOrganizationRequest.
 * Use `create(CreateOrganizationRequestSchema)` to create a new message.
 */
export const CreateOrganizationRequestSchema: GenMessage<CreateOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 1);

/**
 * @generated from message domain.CreateOrganizationRequest.ParentOrganizationInfo
 */
export type CreateOrganizationRequest_ParentOrganizationInfo = Message<"domain.CreateOrganizationRequest.ParentOrganizationInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * locks the new organizations admin profile with the parent organization admin profile
   * NOTE: this is kept here instead of in admin_profile to avoid ambiguities in profile lock order (as there are no IDs yet)
   *
   * @generated from field: domain.ProfileProfileLock downstream_admin_profile_lock = 2;
   */
  downstreamAdminProfileLock?: ProfileProfileLock | undefined;
};

/**
 * Describes the message domain.CreateOrganizationRequest.ParentOrganizationInfo.
 * Use `create(CreateOrganizationRequest_ParentOrganizationInfoSchema)` to create a new message.
 */
export const CreateOrganizationRequest_ParentOrganizationInfoSchema: GenMessage<CreateOrganizationRequest_ParentOrganizationInfo> = /*@__PURE__*/
  messageDesc(file_organization_service, 1, 0);

/**
 * @generated from message domain.CreateOrganizationResponse
 */
export type CreateOrganizationResponse = Message<"domain.CreateOrganizationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string super_user_id = 3;
   */
  superUserId: string;

  /**
   * @generated from field: string authenticator_id = 4;
   */
  authenticatorId: string;

  /**
   * @generated from field: string personal_vault_id = 6;
   */
  personalVaultId: string;

  /**
   * @generated from field: string team_vault_id = 7;
   */
  teamVaultId: string;

  /**
   * @generated from field: string team_associated_vault_id = 8;
   */
  teamAssociatedVaultId: string;

  /**
   * @generated from field: string profile_id = 9;
   */
  profileId: string;

  /**
   * @generated from field: string admin_profile_id = 10;
   */
  adminProfileId: string;

  /**
   * @generated from field: string admin_vault_id = 11;
   */
  adminVaultId: string;

  /**
   * @generated from field: string login_summary_vault_id = 12;
   */
  loginSummaryVaultId: string;
};

/**
 * Describes the message domain.CreateOrganizationResponse.
 * Use `create(CreateOrganizationResponseSchema)` to create a new message.
 */
export const CreateOrganizationResponseSchema: GenMessage<CreateOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 2);

/**
 * @generated from message domain.UpdateOrganizationRequest
 */
export type UpdateOrganizationRequest = Message<"domain.UpdateOrganizationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * no change if null
   *
   * @generated from field: google.protobuf.StringValue name = 2;
   */
  name?: string | undefined;

  /**
   * @generated from field: google.protobuf.StringValue icon = 3;
   */
  icon?: string | undefined;

  /**
   * @generated from field: google.protobuf.BoolValue restrict_create_team = 4;
   */
  restrictCreateTeam?: boolean | undefined;

  /**
   * @generated from field: google.protobuf.BoolValue auditlog_enable = 5;
   */
  auditlogEnable?: boolean | undefined;

  /**
   * @generated from field: google.protobuf.BoolValue child_organization_management_enable = 11;
   */
  childOrganizationManagementEnable?: boolean | undefined;

  /**
   * @generated from field: google.protobuf.BoolValue restrict_personal_logins = 8;
   */
  restrictPersonalLogins?: boolean | undefined;

  /**
   * @generated from field: domain.UpdateOrganizationRequest.StringArray monitored_domains = 7;
   */
  monitoredDomains?: UpdateOrganizationRequest_StringArray | undefined;

  /**
   * @generated from field: google.protobuf.StringValue password_policy = 9;
   */
  passwordPolicy?: string | undefined;

  /**
   * @generated from field: domain.UnlockTimeLimit unlock_time_limit = 10;
   */
  unlockTimeLimit?: UnlockTimeLimit | undefined;

  /**
   * @generated from field: google.protobuf.StringValue client_settings = 12;
   */
  clientSettings?: string | undefined;

  /**
   * @generated from field: google.protobuf.StringValue share_link_sender_email = 13;
   */
  shareLinkSenderEmail?: string | undefined;

  /**
   * @generated from field: google.protobuf.BoolValue entra_prefer_user_principal_name = 14;
   */
  entraPreferUserPrincipalName?: boolean | undefined;

  /**
   * @generated from field: google.protobuf.BoolValue role_management_enable = 16;
   */
  roleManagementEnable?: boolean | undefined;

  /**
   * @generated from field: domain.UpdateOrganizationRequest.ExportPermissionValue user_role_export_permission = 17;
   */
  userRoleExportPermission?: UpdateOrganizationRequest_ExportPermissionValue | undefined;
};

/**
 * Describes the message domain.UpdateOrganizationRequest.
 * Use `create(UpdateOrganizationRequestSchema)` to create a new message.
 */
export const UpdateOrganizationRequestSchema: GenMessage<UpdateOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 3);

/**
 * @generated from message domain.UpdateOrganizationRequest.StringArray
 */
export type UpdateOrganizationRequest_StringArray = Message<"domain.UpdateOrganizationRequest.StringArray"> & {
  /**
   * @generated from field: repeated string value = 1;
   */
  value: string[];
};

/**
 * Describes the message domain.UpdateOrganizationRequest.StringArray.
 * Use `create(UpdateOrganizationRequest_StringArraySchema)` to create a new message.
 */
export const UpdateOrganizationRequest_StringArraySchema: GenMessage<UpdateOrganizationRequest_StringArray> = /*@__PURE__*/
  messageDesc(file_organization_service, 3, 0);

/**
 * @generated from message domain.UpdateOrganizationRequest.ExportPermissionValue
 */
export type UpdateOrganizationRequest_ExportPermissionValue = Message<"domain.UpdateOrganizationRequest.ExportPermissionValue"> & {
  /**
   * @generated from field: domain.ExportPermission value = 1;
   */
  value: ExportPermission;
};

/**
 * Describes the message domain.UpdateOrganizationRequest.ExportPermissionValue.
 * Use `create(UpdateOrganizationRequest_ExportPermissionValueSchema)` to create a new message.
 */
export const UpdateOrganizationRequest_ExportPermissionValueSchema: GenMessage<UpdateOrganizationRequest_ExportPermissionValue> = /*@__PURE__*/
  messageDesc(file_organization_service, 3, 1);

/**
 * @generated from message domain.UpdateOrganizationResponse
 */
export type UpdateOrganizationResponse = Message<"domain.UpdateOrganizationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.UpdateOrganizationResponse.
 * Use `create(UpdateOrganizationResponseSchema)` to create a new message.
 */
export const UpdateOrganizationResponseSchema: GenMessage<UpdateOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 4);

/**
 * @generated from message domain.ModifyMembersRequest
 */
export type ModifyMembersRequest = Message<"domain.ModifyMembersRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: repeated domain.ModifyMembersRequest.CreateProfileOperation create_profile_ops = 7;
   */
  createProfileOps: ModifyMembersRequest_CreateProfileOperation[];

  /**
   * @generated from field: repeated domain.ModifyMembersRequest.UpdateProfileOperation update_profile_ops = 8;
   */
  updateProfileOps: ModifyMembersRequest_UpdateProfileOperation[];

  /**
   * @generated from field: repeated string delete_profile_ids = 9;
   */
  deleteProfileIds: string[];
};

/**
 * Describes the message domain.ModifyMembersRequest.
 * Use `create(ModifyMembersRequestSchema)` to create a new message.
 */
export const ModifyMembersRequestSchema: GenMessage<ModifyMembersRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 5);

/**
 * @generated from message domain.ModifyMembersRequest.CreateProfileOperation
 */
export type ModifyMembersRequest_CreateProfileOperation = Message<"domain.ModifyMembersRequest.CreateProfileOperation"> & {
  /**
   * @generated from field: domain.VaultCreationData personal_vault_data = 3;
   */
  personalVaultData?: VaultCreationData | undefined;

  /**
   * @generated from field: domain.ProfileData profile = 4;
   */
  profile?: ProfileData | undefined;

  /**
   * lock to the admin profile, must be filled if is_admin is true and admin profile enabled
   *
   * @generated from field: domain.ProfileProfileLock admin_profile_lock = 9;
   */
  adminProfileLock?: ProfileProfileLock | undefined;

  /**
   * @generated from field: string email = 6;
   */
  email: string;

  /**
   * @generated from field: bool create_start_code_and_send_mail = 8;
   */
  createStartCodeAndSendMail: boolean;

  /**
   * @generated from field: bool set_start_code_email_sender = 11;
   */
  setStartCodeEmailSender: boolean;

  /**
   * if set, the entra user email will be used instead of email(6)
   *
   * @generated from field: string entra_user_id = 10;
   */
  entraUserId: string;

  /**
   * @generated from field: repeated string role_ids = 12;
   */
  roleIds: string[];
};

/**
 * Describes the message domain.ModifyMembersRequest.CreateProfileOperation.
 * Use `create(ModifyMembersRequest_CreateProfileOperationSchema)` to create a new message.
 */
export const ModifyMembersRequest_CreateProfileOperationSchema: GenMessage<ModifyMembersRequest_CreateProfileOperation> = /*@__PURE__*/
  messageDesc(file_organization_service, 5, 0);

/**
 * @generated from message domain.ModifyMembersRequest.UpdateProfileOperation
 */
export type ModifyMembersRequest_UpdateProfileOperation = Message<"domain.ModifyMembersRequest.UpdateProfileOperation"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;

  /**
   * lock to the admin profile, must be filled if is_admin is true and admin profile enabled
   *
   * @generated from field: domain.ProfileProfileLock admin_profile_lock = 4;
   */
  adminProfileLock?: ProfileProfileLock | undefined;

  /**
   * @generated from field: google.protobuf.StringValue role_id = 6;
   */
  roleId?: string | undefined;
};

/**
 * Describes the message domain.ModifyMembersRequest.UpdateProfileOperation.
 * Use `create(ModifyMembersRequest_UpdateProfileOperationSchema)` to create a new message.
 */
export const ModifyMembersRequest_UpdateProfileOperationSchema: GenMessage<ModifyMembersRequest_UpdateProfileOperation> = /*@__PURE__*/
  messageDesc(file_organization_service, 5, 1);

/**
 * @generated from message domain.ModifyMembersResponse
 */
export type ModifyMembersResponse = Message<"domain.ModifyMembersResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: repeated string personal_vault_ids = 2;
   */
  personalVaultIds: string[];
};

/**
 * Describes the message domain.ModifyMembersResponse.
 * Use `create(ModifyMembersResponseSchema)` to create a new message.
 */
export const ModifyMembersResponseSchema: GenMessage<ModifyMembersResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 6);

/**
 * @generated from message domain.CreateServiceProfileRequest
 */
export type CreateServiceProfileRequest = Message<"domain.CreateServiceProfileRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: domain.ProfileData profile = 2;
   */
  profile?: ProfileData | undefined;

  /**
   * @generated from field: domain.ProfileProfileLock downstream_admin_profile_lock = 3;
   */
  downstreamAdminProfileLock?: ProfileProfileLock | undefined;
};

/**
 * Describes the message domain.CreateServiceProfileRequest.
 * Use `create(CreateServiceProfileRequestSchema)` to create a new message.
 */
export const CreateServiceProfileRequestSchema: GenMessage<CreateServiceProfileRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 7);

/**
 * @generated from message domain.CreateServiceProfileResponse
 */
export type CreateServiceProfileResponse = Message<"domain.CreateServiceProfileResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: string profile_id = 2;
   */
  profileId: string;
};

/**
 * Describes the message domain.CreateServiceProfileResponse.
 * Use `create(CreateServiceProfileResponseSchema)` to create a new message.
 */
export const CreateServiceProfileResponseSchema: GenMessage<CreateServiceProfileResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 8);

/**
 * @generated from message domain.LeaveOrganizationRequest
 */
export type LeaveOrganizationRequest = Message<"domain.LeaveOrganizationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.LeaveOrganizationRequest.
 * Use `create(LeaveOrganizationRequestSchema)` to create a new message.
 */
export const LeaveOrganizationRequestSchema: GenMessage<LeaveOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 9);

/**
 * @generated from message domain.LeaveOrganizationResponse
 */
export type LeaveOrganizationResponse = Message<"domain.LeaveOrganizationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.LeaveOrganizationResponse.
 * Use `create(LeaveOrganizationResponseSchema)` to create a new message.
 */
export const LeaveOrganizationResponseSchema: GenMessage<LeaveOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 10);

/**
 * @generated from message domain.AcceptInviteRequest
 */
export type AcceptInviteRequest = Message<"domain.AcceptInviteRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.AcceptInviteRequest.
 * Use `create(AcceptInviteRequestSchema)` to create a new message.
 */
export const AcceptInviteRequestSchema: GenMessage<AcceptInviteRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 11);

/**
 * @generated from message domain.AcceptInviteResponse
 */
export type AcceptInviteResponse = Message<"domain.AcceptInviteResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.AcceptInviteResponse.
 * Use `create(AcceptInviteResponseSchema)` to create a new message.
 */
export const AcceptInviteResponseSchema: GenMessage<AcceptInviteResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 12);

/**
 * @generated from message domain.RedeemCouponRequest
 */
export type RedeemCouponRequest = Message<"domain.RedeemCouponRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string coupon_text = 2;
   */
  couponText: string;
};

/**
 * Describes the message domain.RedeemCouponRequest.
 * Use `create(RedeemCouponRequestSchema)` to create a new message.
 */
export const RedeemCouponRequestSchema: GenMessage<RedeemCouponRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 13);

/**
 * @generated from message domain.RedeemCouponResponse
 */
export type RedeemCouponResponse = Message<"domain.RedeemCouponResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.RedeemCouponResponse.
 * Use `create(RedeemCouponResponseSchema)` to create a new message.
 */
export const RedeemCouponResponseSchema: GenMessage<RedeemCouponResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 14);

/**
 * @generated from message domain.DeleteOrganizationRequest
 */
export type DeleteOrganizationRequest = Message<"domain.DeleteOrganizationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.DeleteOrganizationRequest.
 * Use `create(DeleteOrganizationRequestSchema)` to create a new message.
 */
export const DeleteOrganizationRequestSchema: GenMessage<DeleteOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 15);

/**
 * @generated from message domain.DeleteOrganizationResponse
 */
export type DeleteOrganizationResponse = Message<"domain.DeleteOrganizationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.DeleteOrganizationResponse.
 * Use `create(DeleteOrganizationResponseSchema)` to create a new message.
 */
export const DeleteOrganizationResponseSchema: GenMessage<DeleteOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 16);

/**
 * @generated from message domain.GetSubscriptionDetailsRequest
 */
export type GetSubscriptionDetailsRequest = Message<"domain.GetSubscriptionDetailsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.GetSubscriptionDetailsRequest.
 * Use `create(GetSubscriptionDetailsRequestSchema)` to create a new message.
 */
export const GetSubscriptionDetailsRequestSchema: GenMessage<GetSubscriptionDetailsRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 17);

/**
 * @generated from message domain.GetSubscriptionDetailsResponse
 */
export type GetSubscriptionDetailsResponse = Message<"domain.GetSubscriptionDetailsResponse"> & {
  /**
   * @generated from field: repeated domain.GetSubscriptionDetailsResponse.Payment payments = 1;
   */
  payments: GetSubscriptionDetailsResponse_Payment[];

  /**
   * @generated from field: domain.GetSubscriptionDetailsResponse.PaddleSubscription paddle_subscription = 4;
   */
  paddleSubscription?: GetSubscriptionDetailsResponse_PaddleSubscription | undefined;

  /**
   * @generated from field: domain.SubscriptionStatus status = 5;
   */
  status?: SubscriptionStatus | undefined;

  /**
   * @generated from field: int32 billable_users = 6;
   */
  billableUsers: number;
};

/**
 * Describes the message domain.GetSubscriptionDetailsResponse.
 * Use `create(GetSubscriptionDetailsResponseSchema)` to create a new message.
 */
export const GetSubscriptionDetailsResponseSchema: GenMessage<GetSubscriptionDetailsResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 18);

/**
 * see https://developer.paddle.com/webhook-reference/ZG9jOjI1MzUzOTk3-subscription-payment-succeeded
 *
 * @generated from message domain.GetSubscriptionDetailsResponse.Payment
 */
export type GetSubscriptionDetailsResponse_Payment = Message<"domain.GetSubscriptionDetailsResponse.Payment"> & {
  /**
   * @generated from field: google.protobuf.Timestamp event_time = 1;
   */
  eventTime?: Timestamp | undefined;

  /**
   * @generated from field: string receipt_url = 2;
   */
  receiptUrl: string;

  /**
   * @generated from field: int64 sale_gross_cents = 3;
   */
  saleGrossCents: bigint;

  /**
   * @generated from field: int64 payment_tax_cents = 4;
   */
  paymentTaxCents: bigint;

  /**
   * @generated from field: string currency = 5;
   */
  currency: string;

  /**
   * @generated from field: string order_id = 6;
   */
  orderId: string;
};

/**
 * Describes the message domain.GetSubscriptionDetailsResponse.Payment.
 * Use `create(GetSubscriptionDetailsResponse_PaymentSchema)` to create a new message.
 */
export const GetSubscriptionDetailsResponse_PaymentSchema: GenMessage<GetSubscriptionDetailsResponse_Payment> = /*@__PURE__*/
  messageDesc(file_organization_service, 18, 0);

/**
 * @generated from message domain.GetSubscriptionDetailsResponse.PaddleSubscription
 */
export type GetSubscriptionDetailsResponse_PaddleSubscription = Message<"domain.GetSubscriptionDetailsResponse.PaddleSubscription"> & {
  /**
   * @generated from field: domain.SubscriptionPlan plan = 1;
   */
  plan: SubscriptionPlan;

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity: number;

  /**
   * @generated from field: int32 unit_price_cents = 3;
   */
  unitPriceCents: number;

  /**
   * @generated from field: int32 total_price_cents = 4;
   */
  totalPriceCents: number;

  /**
   * @generated from field: string currency = 5;
   */
  currency: string;

  /**
   * @generated from field: google.protobuf.Timestamp next_bill_date = 6;
   */
  nextBillDate?: Timestamp | undefined;
};

/**
 * Describes the message domain.GetSubscriptionDetailsResponse.PaddleSubscription.
 * Use `create(GetSubscriptionDetailsResponse_PaddleSubscriptionSchema)` to create a new message.
 */
export const GetSubscriptionDetailsResponse_PaddleSubscriptionSchema: GenMessage<GetSubscriptionDetailsResponse_PaddleSubscription> = /*@__PURE__*/
  messageDesc(file_organization_service, 18, 1);

/**
 * @generated from message domain.RequestAdditionalLicensesRequest
 */
export type RequestAdditionalLicensesRequest = Message<"domain.RequestAdditionalLicensesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: int32 additional_license_count = 2;
   */
  additionalLicenseCount: number;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message domain.RequestAdditionalLicensesRequest.
 * Use `create(RequestAdditionalLicensesRequestSchema)` to create a new message.
 */
export const RequestAdditionalLicensesRequestSchema: GenMessage<RequestAdditionalLicensesRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 19);

/**
 * empty
 *
 * @generated from message domain.RequestAdditionalLicensesResponse
 */
export type RequestAdditionalLicensesResponse = Message<"domain.RequestAdditionalLicensesResponse"> & {
};

/**
 * Describes the message domain.RequestAdditionalLicensesResponse.
 * Use `create(RequestAdditionalLicensesResponseSchema)` to create a new message.
 */
export const RequestAdditionalLicensesResponseSchema: GenMessage<RequestAdditionalLicensesResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 20);

/**
 * @generated from message domain.RegenerateOrganizationProfileRequest
 */
export type RegenerateOrganizationProfileRequest = Message<"domain.RegenerateOrganizationProfileRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: domain.ProfileRegenerateData profile = 2;
   */
  profile?: ProfileRegenerateData | undefined;

  /**
   * @generated from field: repeated domain.ProfileRegenerateData child_organization_profiles = 4;
   */
  childOrganizationProfiles: ProfileRegenerateData[];

  /**
   * optional, regenerates to free profile if empty
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;
};

/**
 * Describes the message domain.RegenerateOrganizationProfileRequest.
 * Use `create(RegenerateOrganizationProfileRequestSchema)` to create a new message.
 */
export const RegenerateOrganizationProfileRequestSchema: GenMessage<RegenerateOrganizationProfileRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 21);

/**
 * @generated from message domain.RegenerateOrganizationProfileResponse
 */
export type RegenerateOrganizationProfileResponse = Message<"domain.RegenerateOrganizationProfileResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.RegenerateOrganizationProfileResponse.
 * Use `create(RegenerateOrganizationProfileResponseSchema)` to create a new message.
 */
export const RegenerateOrganizationProfileResponseSchema: GenMessage<RegenerateOrganizationProfileResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 22);

/**
 * @generated from message domain.ClaimPreliminaryProfileRequest
 */
export type ClaimPreliminaryProfileRequest = Message<"domain.ClaimPreliminaryProfileRequest"> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string;
};

/**
 * Describes the message domain.ClaimPreliminaryProfileRequest.
 * Use `create(ClaimPreliminaryProfileRequestSchema)` to create a new message.
 */
export const ClaimPreliminaryProfileRequestSchema: GenMessage<ClaimPreliminaryProfileRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 23);

/**
 * @generated from message domain.ClaimPreliminaryProfileResponse
 */
export type ClaimPreliminaryProfileResponse = Message<"domain.ClaimPreliminaryProfileResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.ClaimPreliminaryProfileResponse.
 * Use `create(ClaimPreliminaryProfileResponseSchema)` to create a new message.
 */
export const ClaimPreliminaryProfileResponseSchema: GenMessage<ClaimPreliminaryProfileResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 24);

/**
 * @generated from message domain.RegenerateAdminProfileRequest
 */
export type RegenerateAdminProfileRequest = Message<"domain.RegenerateAdminProfileRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: domain.ProfileRegenerateData profile = 2;
   */
  profile?: ProfileRegenerateData | undefined;
};

/**
 * Describes the message domain.RegenerateAdminProfileRequest.
 * Use `create(RegenerateAdminProfileRequestSchema)` to create a new message.
 */
export const RegenerateAdminProfileRequestSchema: GenMessage<RegenerateAdminProfileRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 25);

/**
 * @generated from message domain.RegenerateAdminProfileResponse
 */
export type RegenerateAdminProfileResponse = Message<"domain.RegenerateAdminProfileResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: string admin_profile_id = 2;
   */
  adminProfileId: string;

  /**
   * @generated from field: string admin_profile_key_generation_id = 3;
   */
  adminProfileKeyGenerationId: string;
};

/**
 * Describes the message domain.RegenerateAdminProfileResponse.
 * Use `create(RegenerateAdminProfileResponseSchema)` to create a new message.
 */
export const RegenerateAdminProfileResponseSchema: GenMessage<RegenerateAdminProfileResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 26);

/**
 * @generated from message domain.RenewProfileStartCodeRequest
 */
export type RenewProfileStartCodeRequest = Message<"domain.RenewProfileStartCodeRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: repeated string profile_ids = 2;
   */
  profileIds: string[];
};

/**
 * Describes the message domain.RenewProfileStartCodeRequest.
 * Use `create(RenewProfileStartCodeRequestSchema)` to create a new message.
 */
export const RenewProfileStartCodeRequestSchema: GenMessage<RenewProfileStartCodeRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 27);

/**
 * @generated from message domain.RenewProfileStartCodeResponse
 */
export type RenewProfileStartCodeResponse = Message<"domain.RenewProfileStartCodeResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.RenewProfileStartCodeResponse.
 * Use `create(RenewProfileStartCodeResponseSchema)` to create a new message.
 */
export const RenewProfileStartCodeResponseSchema: GenMessage<RenewProfileStartCodeResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 28);

/**
 * @generated from message domain.SendStartCodeEmailRequest
 */
export type SendStartCodeEmailRequest = Message<"domain.SendStartCodeEmailRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: repeated string profile_ids = 2;
   */
  profileIds: string[];
};

/**
 * Describes the message domain.SendStartCodeEmailRequest.
 * Use `create(SendStartCodeEmailRequestSchema)` to create a new message.
 */
export const SendStartCodeEmailRequestSchema: GenMessage<SendStartCodeEmailRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 29);

/**
 * @generated from message domain.SendStartCodeEmailResponse
 */
export type SendStartCodeEmailResponse = Message<"domain.SendStartCodeEmailResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.SendStartCodeEmailResponse.
 * Use `create(SendStartCodeEmailResponseSchema)` to create a new message.
 */
export const SendStartCodeEmailResponseSchema: GenMessage<SendStartCodeEmailResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 30);

/**
 * @generated from message domain.RevokeProfileStartCodeRequest
 */
export type RevokeProfileStartCodeRequest = Message<"domain.RevokeProfileStartCodeRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: repeated string profile_ids = 2;
   */
  profileIds: string[];
};

/**
 * Describes the message domain.RevokeProfileStartCodeRequest.
 * Use `create(RevokeProfileStartCodeRequestSchema)` to create a new message.
 */
export const RevokeProfileStartCodeRequestSchema: GenMessage<RevokeProfileStartCodeRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 31);

/**
 * @generated from message domain.RevokeProfileStartCodeResponse
 */
export type RevokeProfileStartCodeResponse = Message<"domain.RevokeProfileStartCodeResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.RevokeProfileStartCodeResponse.
 * Use `create(RevokeProfileStartCodeResponseSchema)` to create a new message.
 */
export const RevokeProfileStartCodeResponseSchema: GenMessage<RevokeProfileStartCodeResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 32);

/**
 * @generated from message domain.GetOrganizationDeletionInfoRequest
 */
export type GetOrganizationDeletionInfoRequest = Message<"domain.GetOrganizationDeletionInfoRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message domain.GetOrganizationDeletionInfoRequest.
 * Use `create(GetOrganizationDeletionInfoRequestSchema)` to create a new message.
 */
export const GetOrganizationDeletionInfoRequestSchema: GenMessage<GetOrganizationDeletionInfoRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 33);

/**
 * @generated from message domain.GetOrganizationDeletionInfoResponse
 */
export type GetOrganizationDeletionInfoResponse = Message<"domain.GetOrganizationDeletionInfoResponse"> & {
  /**
   * @generated from field: string organization_name = 1;
   */
  organizationName: string;

  /**
   * @generated from field: string requested_by_email = 2;
   */
  requestedByEmail: string;

  /**
   * @generated from field: int32 user_count = 3;
   */
  userCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 4;
   */
  requestedAt?: Timestamp | undefined;
};

/**
 * Describes the message domain.GetOrganizationDeletionInfoResponse.
 * Use `create(GetOrganizationDeletionInfoResponseSchema)` to create a new message.
 */
export const GetOrganizationDeletionInfoResponseSchema: GenMessage<GetOrganizationDeletionInfoResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 34);

/**
 * @generated from message domain.DeleteOrganizationWithTokenRequest
 */
export type DeleteOrganizationWithTokenRequest = Message<"domain.DeleteOrganizationWithTokenRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message domain.DeleteOrganizationWithTokenRequest.
 * Use `create(DeleteOrganizationWithTokenRequestSchema)` to create a new message.
 */
export const DeleteOrganizationWithTokenRequestSchema: GenMessage<DeleteOrganizationWithTokenRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 35);

/**
 * empty
 *
 * @generated from message domain.DeleteOrganizationWithTokenResponse
 */
export type DeleteOrganizationWithTokenResponse = Message<"domain.DeleteOrganizationWithTokenResponse"> & {
};

/**
 * Describes the message domain.DeleteOrganizationWithTokenResponse.
 * Use `create(DeleteOrganizationWithTokenResponseSchema)` to create a new message.
 */
export const DeleteOrganizationWithTokenResponseSchema: GenMessage<DeleteOrganizationWithTokenResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 36);

/**
 * @generated from message domain.RemoveOrganizationDeletionTokenRequest
 */
export type RemoveOrganizationDeletionTokenRequest = Message<"domain.RemoveOrganizationDeletionTokenRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message domain.RemoveOrganizationDeletionTokenRequest.
 * Use `create(RemoveOrganizationDeletionTokenRequestSchema)` to create a new message.
 */
export const RemoveOrganizationDeletionTokenRequestSchema: GenMessage<RemoveOrganizationDeletionTokenRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 37);

/**
 * empty
 *
 * @generated from message domain.RemoveOrganizationDeletionTokenResponse
 */
export type RemoveOrganizationDeletionTokenResponse = Message<"domain.RemoveOrganizationDeletionTokenResponse"> & {
};

/**
 * Describes the message domain.RemoveOrganizationDeletionTokenResponse.
 * Use `create(RemoveOrganizationDeletionTokenResponseSchema)` to create a new message.
 */
export const RemoveOrganizationDeletionTokenResponseSchema: GenMessage<RemoveOrganizationDeletionTokenResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 38);

/**
 * @generated from message domain.GetBreachDataRequest
 */
export type GetBreachDataRequest = Message<"domain.GetBreachDataRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.GetBreachDataRequest.
 * Use `create(GetBreachDataRequestSchema)` to create a new message.
 */
export const GetBreachDataRequestSchema: GenMessage<GetBreachDataRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 39);

/**
 * @generated from message domain.GetBreachDataResponse
 */
export type GetBreachDataResponse = Message<"domain.GetBreachDataResponse"> & {
  /**
   * @generated from field: repeated domain.GetBreachDataResponse.MonitoredDomain domains = 1;
   */
  domains: GetBreachDataResponse_MonitoredDomain[];

  /**
   * general hibp stats
   *
   * @generated from field: google.protobuf.Timestamp last_check_date = 2;
   */
  lastCheckDate?: Timestamp | undefined;

  /**
   * @generated from field: float total_pwn_count_billions = 3;
   */
  totalPwnCountBillions: number;

  /**
   * @generated from field: int32 total_breach_count = 4;
   */
  totalBreachCount: number;
};

/**
 * Describes the message domain.GetBreachDataResponse.
 * Use `create(GetBreachDataResponseSchema)` to create a new message.
 */
export const GetBreachDataResponseSchema: GenMessage<GetBreachDataResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 40);

/**
 * corresponds to https://haveibeenpwned.com/API/v3#BreachModel
 *
 * @generated from message domain.GetBreachDataResponse.BreachModel
 */
export type GetBreachDataResponse_BreachModel = Message<"domain.GetBreachDataResponse.BreachModel"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: google.protobuf.Timestamp breach_date = 3;
   */
  breachDate?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp added_date = 4;
   */
  addedDate?: Timestamp | undefined;

  /**
   * @generated from field: repeated string data_classes = 5;
   */
  dataClasses: string[];

  /**
   * looked up under /hibplogos/ on the client's public data server
   *
   * @generated from field: string logo_file_name = 7;
   */
  logoFileName: string;
};

/**
 * Describes the message domain.GetBreachDataResponse.BreachModel.
 * Use `create(GetBreachDataResponse_BreachModelSchema)` to create a new message.
 */
export const GetBreachDataResponse_BreachModelSchema: GenMessage<GetBreachDataResponse_BreachModel> = /*@__PURE__*/
  messageDesc(file_organization_service, 40, 0);

/**
 * @generated from message domain.GetBreachDataResponse.Breach
 */
export type GetBreachDataResponse_Breach = Message<"domain.GetBreachDataResponse.Breach"> & {
  /**
   * @generated from field: domain.GetBreachDataResponse.BreachModel model = 1;
   */
  model?: GetBreachDataResponse_BreachModel | undefined;

  /**
   * @generated from field: repeated string aliases = 2;
   */
  aliases: string[];
};

/**
 * Describes the message domain.GetBreachDataResponse.Breach.
 * Use `create(GetBreachDataResponse_BreachSchema)` to create a new message.
 */
export const GetBreachDataResponse_BreachSchema: GenMessage<GetBreachDataResponse_Breach> = /*@__PURE__*/
  messageDesc(file_organization_service, 40, 1);

/**
 * @generated from message domain.GetBreachDataResponse.MonitoredDomain
 */
export type GetBreachDataResponse_MonitoredDomain = Message<"domain.GetBreachDataResponse.MonitoredDomain"> & {
  /**
   * @generated from field: string domain = 1;
   */
  domain: string;

  /**
   * @generated from field: repeated domain.GetBreachDataResponse.Breach breaches = 2;
   */
  breaches: GetBreachDataResponse_Breach[];
};

/**
 * Describes the message domain.GetBreachDataResponse.MonitoredDomain.
 * Use `create(GetBreachDataResponse_MonitoredDomainSchema)` to create a new message.
 */
export const GetBreachDataResponse_MonitoredDomainSchema: GenMessage<GetBreachDataResponse_MonitoredDomain> = /*@__PURE__*/
  messageDesc(file_organization_service, 40, 2);

/**
 * @generated from message domain.ListLocksForProfileRegenerateRequest
 */
export type ListLocksForProfileRegenerateRequest = Message<"domain.ListLocksForProfileRegenerateRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string profile_id = 2;
   */
  profileId: string;
};

/**
 * Describes the message domain.ListLocksForProfileRegenerateRequest.
 * Use `create(ListLocksForProfileRegenerateRequestSchema)` to create a new message.
 */
export const ListLocksForProfileRegenerateRequestSchema: GenMessage<ListLocksForProfileRegenerateRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 41);

/**
 * @generated from message domain.ListLocksForProfileRegenerateResponse
 */
export type ListLocksForProfileRegenerateResponse = Message<"domain.ListLocksForProfileRegenerateResponse"> & {
  /**
   * @generated from field: repeated domain.ListLocksForProfileRegenerateResponse.Vault vaults = 1;
   */
  vaults: ListLocksForProfileRegenerateResponse_Vault[];

  /**
   * @generated from field: repeated domain.ListLocksForProfileRegenerateResponse.ChildOrganization child_organizations = 2;
   */
  childOrganizations: ListLocksForProfileRegenerateResponse_ChildOrganization[];
};

/**
 * Describes the message domain.ListLocksForProfileRegenerateResponse.
 * Use `create(ListLocksForProfileRegenerateResponseSchema)` to create a new message.
 */
export const ListLocksForProfileRegenerateResponseSchema: GenMessage<ListLocksForProfileRegenerateResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 42);

/**
 * @generated from message domain.ListLocksForProfileRegenerateResponse.Vault
 */
export type ListLocksForProfileRegenerateResponse_Vault = Message<"domain.ListLocksForProfileRegenerateResponse.Vault"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string generation_id = 2;
   */
  generationId: string;

  /**
   * @generated from field: domain.VaultProfileLock admin_vault_profile_lock = 3;
   */
  adminVaultProfileLock?: VaultProfileLock | undefined;
};

/**
 * Describes the message domain.ListLocksForProfileRegenerateResponse.Vault.
 * Use `create(ListLocksForProfileRegenerateResponse_VaultSchema)` to create a new message.
 */
export const ListLocksForProfileRegenerateResponse_VaultSchema: GenMessage<ListLocksForProfileRegenerateResponse_Vault> = /*@__PURE__*/
  messageDesc(file_organization_service, 42, 0);

/**
 * @generated from message domain.ListLocksForProfileRegenerateResponse.ChildOrganization
 */
export type ListLocksForProfileRegenerateResponse_ChildOrganization = Message<"domain.ListLocksForProfileRegenerateResponse.ChildOrganization"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string profile_id = 2;
   */
  profileId: string;

  /**
   * @generated from field: domain.SyncUpdateProfile admin_profile = 3;
   */
  adminProfile?: SyncUpdateProfile | undefined;

  /**
   * @generated from field: repeated domain.ListLocksForProfileRegenerateResponse.Vault vaults = 4;
   */
  vaults: ListLocksForProfileRegenerateResponse_Vault[];
};

/**
 * Describes the message domain.ListLocksForProfileRegenerateResponse.ChildOrganization.
 * Use `create(ListLocksForProfileRegenerateResponse_ChildOrganizationSchema)` to create a new message.
 */
export const ListLocksForProfileRegenerateResponse_ChildOrganizationSchema: GenMessage<ListLocksForProfileRegenerateResponse_ChildOrganization> = /*@__PURE__*/
  messageDesc(file_organization_service, 42, 1);

/**
 * @generated from message domain.CreateLoginSummaryVaultRequest
 */
export type CreateLoginSummaryVaultRequest = Message<"domain.CreateLoginSummaryVaultRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: domain.VaultCreationData login_summary_vault_data = 2;
   */
  loginSummaryVaultData?: VaultCreationData | undefined;
};

/**
 * Describes the message domain.CreateLoginSummaryVaultRequest.
 * Use `create(CreateLoginSummaryVaultRequestSchema)` to create a new message.
 */
export const CreateLoginSummaryVaultRequestSchema: GenMessage<CreateLoginSummaryVaultRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 43);

/**
 * @generated from message domain.CreateLoginSummaryVaultResponse
 */
export type CreateLoginSummaryVaultResponse = Message<"domain.CreateLoginSummaryVaultResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: string login_summary_vault_id = 2;
   */
  loginSummaryVaultId: string;
};

/**
 * Describes the message domain.CreateLoginSummaryVaultResponse.
 * Use `create(CreateLoginSummaryVaultResponseSchema)` to create a new message.
 */
export const CreateLoginSummaryVaultResponseSchema: GenMessage<CreateLoginSummaryVaultResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 44);

/**
 * @generated from message domain.AddRoleRequest
 */
export type AddRoleRequest = Message<"domain.AddRoleRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string custom_name = 2;
   */
  customName: string;

  /**
   * @generated from field: domain.RolePermissions permissions = 3;
   */
  permissions?: RolePermissions | undefined;
};

/**
 * Describes the message domain.AddRoleRequest.
 * Use `create(AddRoleRequestSchema)` to create a new message.
 */
export const AddRoleRequestSchema: GenMessage<AddRoleRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 45);

/**
 * @generated from message domain.AddRoleResponse
 */
export type AddRoleResponse = Message<"domain.AddRoleResponse"> & {
  /**
   * @generated from field: string role_id = 1;
   */
  roleId: string;

  /**
   * @generated from field: domain.SyncUpdate sync_update = 2;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.AddRoleResponse.
 * Use `create(AddRoleResponseSchema)` to create a new message.
 */
export const AddRoleResponseSchema: GenMessage<AddRoleResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 46);

/**
 * @generated from message domain.UpdateRoleRequest
 */
export type UpdateRoleRequest = Message<"domain.UpdateRoleRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string role_id = 2;
   */
  roleId: string;

  /**
   * @generated from field: google.protobuf.StringValue custom_name = 3;
   */
  customName?: string | undefined;

  /**
   * @generated from field: domain.RolePermissions permissions = 4;
   */
  permissions?: RolePermissions | undefined;

  /**
   * @generated from field: repeated domain.ProfileProfileLock new_admin_profile_profile_locks = 5;
   */
  newAdminProfileProfileLocks: ProfileProfileLock[];
};

/**
 * Describes the message domain.UpdateRoleRequest.
 * Use `create(UpdateRoleRequestSchema)` to create a new message.
 */
export const UpdateRoleRequestSchema: GenMessage<UpdateRoleRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 47);

/**
 * @generated from message domain.UpdateRoleResponse
 */
export type UpdateRoleResponse = Message<"domain.UpdateRoleResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.UpdateRoleResponse.
 * Use `create(UpdateRoleResponseSchema)` to create a new message.
 */
export const UpdateRoleResponseSchema: GenMessage<UpdateRoleResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 48);

/**
 * @generated from message domain.DeleteRoleRequest
 */
export type DeleteRoleRequest = Message<"domain.DeleteRoleRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string role_id = 2;
   */
  roleId: string;
};

/**
 * Describes the message domain.DeleteRoleRequest.
 * Use `create(DeleteRoleRequestSchema)` to create a new message.
 */
export const DeleteRoleRequestSchema: GenMessage<DeleteRoleRequest> = /*@__PURE__*/
  messageDesc(file_organization_service, 49);

/**
 * @generated from message domain.DeleteRoleResponse
 */
export type DeleteRoleResponse = Message<"domain.DeleteRoleResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.DeleteRoleResponse.
 * Use `create(DeleteRoleResponseSchema)` to create a new message.
 */
export const DeleteRoleResponseSchema: GenMessage<DeleteRoleResponse> = /*@__PURE__*/
  messageDesc(file_organization_service, 50);

/**
 * @generated from service domain.OrganizationService
 */
export const OrganizationService: GenService<{
  /**
   * errors:
   * - EmailTaken (20100): email address taken
   * - InvalidEmail (20101): invalid email address
   * - NotAllowedForUserType (20470)
   * - MissingCredentials (30100): not logged in
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - UserNotFound (20400): no account matching credentials
   * - ProfilesLocked (20451): user's profiles are locked and already has a login profile
   * - MissingAuthenticatorBlock (40430): the request is lacking a follow-up authenticator block
   * - InvalidAuthenticatorType (40460): The given authenticator is no organization authenticator
   * - InvalidOrganizationName (60430): name is empty or contains unprintable characters
   * - NotAllowedForOrganization (60101): parent organization is itself a child organization
   * - OrganizationInvalidContact (60431): contact is not json-formatted
   * - ProfileNotFound (70400): tried to create with profile when account is not profile enabled
   * - ClientOutdated (10426): tried to create admin profile org with legacy admin vault
   * - Internal (10500): Internal server error
   *
   * @generated from rpc domain.OrganizationService.Create
   */
  create: {
    methodKind: "unary";
    input: typeof CreateOrganizationRequestSchema;
    output: typeof CreateOrganizationResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): not logged in
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - OrganizationInsufficientAccess (60100): not admin of the given organzation
   * - OrganizationNotFound (60400): not member of the given organization
   * - InvalidOrganizationName (60430): name is empty or contains unprintable characters
   * - NotAllowedForOrganization (60101): trying to enable child org management for org with parent org
   * - BadRequest (10400): trying to disable child org management or giving invalid argument
   * - Internal (10500)
   *
   * @generated from rpc domain.OrganizationService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateOrganizationRequestSchema;
    output: typeof UpdateOrganizationResponseSchema;
  },
  /**
   * errors:
   * - BadRequest (10400): email and entra user id provided in create op
   * - EmailTaken (20100): email address taken
   * - InvalidEmail (20101): invalid email address
   * - MissingCredentials (30100): not logged in
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - UserNotFound (20400): A user added to the organization was not found
   * - UserAlreadyInOrganization (60401): A user added to the organization is already in it
   * - OrganizationInsufficientAccess (60100): Tried to manipulate other members without admin access
   * - OrganizationMissingAdmin (60410): after the call there would be no admin left
   * - LicenseCountExceeded (60480): After this operation the organization would exceed its license count
   * - RoleNotFound (61404)
   * - InvalidRole (61405): a role was specified that is not manually assignable
   * - NotAllowedForUserType (20470): Tried to manipulate a non-default user
   * - VaultOutOfSync (50100)
   * - MissingVault (50420): Tried to add admin without admin vault regenerate data
   * - NotAllowedForProfile (70433): tried to demote a delegated admin
   * - IntegrationNotInitialized (80400): Tried to create profile for integration user without integration
   * - IntegrationUserNotFound (80402): Tried to create profile for non-existent integration user
   * - IntegrationInternal (80500)
   * - AuditlogSubmissionError (90500)
   * - Internal (10500):
   *
   * @generated from rpc domain.OrganizationService.ModifyMembers
   */
  modifyMembers: {
    methodKind: "unary";
    input: typeof ModifyMembersRequestSchema;
    output: typeof ModifyMembersResponseSchema;
  },
  /**
   * errors:
   * - BadRequest (10400): called on an org without admin profiles
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - NotAllowedForOrganization (60101): organization must have admin profiles enabled
   * - OrganizationNotFound (60400): not member of the given organization
   * - UserAlreadyInOrganization (60401): A service user already exists in this organization
   * - OrganizationInsufficientAccess (60100)
   * - MissingProfileProfileLock (70412)
   * - AuditlogSubmissionError (90500)
   * - Internal (10500)
   *
   * @generated from rpc domain.OrganizationService.CreateServiceProfile
   */
  createServiceProfile: {
    methodKind: "unary";
    input: typeof CreateServiceProfileRequestSchema;
    output: typeof CreateServiceProfileResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): not logged in
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - ProfilesLocked (20451)
   * - OrganizationNotFound (60400): not member of the given organization
   * - OrganizationMissingAdmin (60410): after the call there would be no admin left
   * - NotAllowedForProfile (70433): the user has a delegated admin profile
   * - Internal (10500):
   *
   * @generated from rpc domain.OrganizationService.Leave
   */
  leave: {
    methodKind: "unary";
    input: typeof LeaveOrganizationRequestSchema;
    output: typeof LeaveOrganizationResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): not logged in
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - OrganizationNotFound (60400): not member of the given organization
   * - Internal (10500):
   *
   * @generated from rpc domain.OrganizationService.AcceptInvite
   */
  acceptInvite: {
    methodKind: "unary";
    input: typeof AcceptInviteRequestSchema;
    output: typeof AcceptInviteResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): not logged in
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - OrganizationInsufficientAccess (60100): not admin of the given organzation
   * - OrganizationNotFound (60400): not member of the given organization
   * - CouponInvalid (60440)
   * - CouponAlreadyRedeemed (60441)
   * - CouponIncompatible (60442)
   * - Internal (10500):
   *
   * @generated from rpc domain.OrganizationService.RedeemCoupon
   */
  redeemCoupon: {
    methodKind: "unary";
    input: typeof RedeemCouponRequestSchema;
    output: typeof RedeemCouponResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100): not logged in
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - OrganizationInsufficientAccess (60100): not admin of the given organzation
   * - OrganizationNotFound (60400): not member of the given organization
   * - NotAllowedForOrganization (60101): organization still has child organizations
   * - Internal (10500):
   *
   * @generated from rpc domain.OrganizationService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteOrganizationRequestSchema;
    output: typeof DeleteOrganizationResponseSchema;
  },
  /**
   * - MissingCredentials (30100): not logged in
   * - UserNotFound (20400): no account matching credentials
   * - OrganizationInsufficientAccess (60100): not admin of the given organzation
   * - OrganizationNotFound (60400): not member of the given organization
   * - Internal (10500):
   *
   * @generated from rpc domain.OrganizationService.GetSubscriptionDetails
   */
  getSubscriptionDetails: {
    methodKind: "unary";
    input: typeof GetSubscriptionDetailsRequestSchema;
    output: typeof GetSubscriptionDetailsResponseSchema;
  },
  /**
   * - BadRequest (10400): called with invalid additional_license_count
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100)
   * - NotAllowedForOrganization (60101): organization has incompatible license
   * - Internal (10500)
   *
   * @generated from rpc domain.OrganizationService.RequestAdditionalLicenses
   */
  requestAdditionalLicenses: {
    methodKind: "unary";
    input: typeof RequestAdditionalLicensesRequestSchema;
    output: typeof RequestAdditionalLicensesResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - UserNotFound (20400): user to assign profile was not found
   * - OrganizationInsufficientAccess (60100): not admin of the given organzation
   * - UserAlreadyInOrganization (60401): user to assign profile is already in organization
   * - OtherProfileEmailConflicts (60450): another profile with this email address exists
   * - ProfileNotFound (70400): if profile not found, or is user's own profile
   * - ProfileOutOfSync (70400): if KeyGenerationId is not the null uuid, or authenticator locks are not empty
   * - MissingProfileAuthenticatorLock (70410)
   * - NotAllowedForProfile (70433): a delegated admin profile is regenerated to free
   * - AuditlogSubmissionError (90500)
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.OrganizationService.RegenerateOrganizationProfile
   */
  regenerateOrganizationProfile: {
    methodKind: "unary";
    input: typeof RegenerateOrganizationProfileRequestSchema;
    output: typeof RegenerateOrganizationProfileResponseSchema;
  },
  /**
   * errors:
   * - BadRequest (10400): if authenticator locks are not empty and org is admin profile enabled
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - VaultOutOfSync (50100)
   * - EmptyCommit (50200)
   * - MissingVault (50420): admin vault creation data is missing
   * - VaultOutOfSync (50100): admin vault already exists, but creation data was provided
   * - MissingVaultProfileLock (50411): if vault profile locks do not match all organization vaults
   * - OrganizationInsufficientAccess (60100)
   * - ProfileOutOfSync (70400): if KeyGenerationId does not match / is the null uuid for creation
   * - Internal (10500)
   *
   * @generated from rpc domain.OrganizationService.RegenerateAdminProfile
   */
  regenerateAdminProfile: {
    methodKind: "unary";
    input: typeof RegenerateAdminProfileRequestSchema;
    output: typeof RegenerateAdminProfileResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationInsufficientAccess (60100): not admin of the given organzation
   * - ProfileNotFound (70400): if profile not found or is not free
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.OrganizationService.RenewProfileStartCode
   */
  renewProfileStartCode: {
    methodKind: "unary";
    input: typeof RenewProfileStartCodeRequestSchema;
    output: typeof RenewProfileStartCodeResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationInsufficientAccess (60100): not admin of the given organzation
   * - ProfileNotFound (70400): if profile not found, is not free or has no start code
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.OrganizationService.SendStartCodeEmail
   */
  sendStartCodeEmail: {
    methodKind: "unary";
    input: typeof SendStartCodeEmailRequestSchema;
    output: typeof SendStartCodeEmailResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationInsufficientAccess (60100): not admin of the given organzation
   * - ProfileNotFound (70400): if profile not found or is not free
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.OrganizationService.RevokeProfileStartCode
   */
  revokeProfileStartCode: {
    methodKind: "unary";
    input: typeof RevokeProfileStartCodeRequestSchema;
    output: typeof RevokeProfileStartCodeResponseSchema;
  },
  /**
   * errors:
   * - OrganizationNotFound (60400)
   * - InvalidOrganizationDeletionToken (60460)
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.OrganizationService.GetDeletionInfo
   */
  getDeletionInfo: {
    methodKind: "unary";
    input: typeof GetOrganizationDeletionInfoRequestSchema;
    output: typeof GetOrganizationDeletionInfoResponseSchema;
  },
  /**
   * errors:
   * - OrganizationNotFound (60400)
   * - InvalidOrganizationDeletionToken (60460)
   * - NotAllowedForOrganization (60101): organization still has child organizations
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.OrganizationService.DeleteWithToken
   */
  deleteWithToken: {
    methodKind: "unary";
    input: typeof DeleteOrganizationWithTokenRequestSchema;
    output: typeof DeleteOrganizationWithTokenResponseSchema;
  },
  /**
   * errors:
   * - OrganizationNotFound (60400)
   * - InvalidOrganizationDeletionToken (60460)
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.OrganizationService.RemoveDeletionToken
   */
  removeDeletionToken: {
    methodKind: "unary";
    input: typeof RemoveOrganizationDeletionTokenRequestSchema;
    output: typeof RemoveOrganizationDeletionTokenResponseSchema;
  },
  /**
   * errors:
   * - OrganizationNotFound (60400)
   * - Unavailable (10503): cannot reach HIBP
   * - Internal (10500)
   *
   * @generated from rpc domain.OrganizationService.GetBreachData
   */
  getBreachData: {
    methodKind: "unary";
    input: typeof GetBreachDataRequestSchema;
    output: typeof GetBreachDataResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - NotAllowedForOrganization (60101): organization is not migrated to admin profiles yet
   * - ProfileNotFound (70400)
   * - Internal (10500)
   *
   * @generated from rpc domain.OrganizationService.ListLocksForProfileRegenerate
   */
  listLocksForProfileRegenerate: {
    methodKind: "unary";
    input: typeof ListLocksForProfileRegenerateRequestSchema;
    output: typeof ListLocksForProfileRegenerateResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - ConflictingVaultExists (50401): a login summary vault already 
   * - MissingVaultProfileLock (50411): no admin profile lock given for vault
   * - MissingVault (50420): vault creation data is missing
   * - MissingVaultMessagePublicKey (50461): no message public key was provided
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100): not admin of the given organization
   * - ProfileNotFound (70400): org is not admin profile enabled
   * - AuditlogSubmissionError (90500)
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.OrganizationService.CreateLoginSummaryVault
   */
  createLoginSummaryVault: {
    methodKind: "unary";
    input: typeof CreateLoginSummaryVaultRequestSchema;
    output: typeof CreateLoginSummaryVaultResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - BadRequest (10400): updating name of special role
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100): not admin of the given organization
   * - NotAllowedForOrganization (60101): organization role management is not enabled
   * - Internal (10500)
   *
   * @generated from rpc domain.OrganizationService.AddRole
   */
  addRole: {
    methodKind: "unary";
    input: typeof AddRoleRequestSchema;
    output: typeof AddRoleResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100): not admin of the given organization
   * - NotAllowedForOrganization (60101): organization role management not enabled or legacy organization
   * - RoleNotFound (61404)
   * - NotAllowedForRole (61406): making a forbidden change to a role
   * - MissingProfileProfileLock (70412): missing lock for role profile when making privileged
   * - Internal (10500)
   *
   * @generated from rpc domain.OrganizationService.UpdateRole
   */
  updateRole: {
    methodKind: "unary";
    input: typeof UpdateRoleRequestSchema;
    output: typeof UpdateRoleResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - OrganizationNotFound (60400)
   * - OrganizationInsufficientAccess (60100): not admin of the given organization
   * - NotAllowedForOrganization (60101): organization role management is not enabled
   * - RoleNotFound (61404)
   * - NotAllowedForRole (61406): deleting standard role or role with profiles assigned
   * - Internal (10500)
   *
   * @generated from rpc domain.OrganizationService.DeleteRole
   */
  deleteRole: {
    methodKind: "unary";
    input: typeof DeleteRoleRequestSchema;
    output: typeof DeleteRoleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_organization_service, 0);

